import { ApplicantProfile, Application, Field } from '@bybeam/platform-types';

export interface ReviewAnswerProps<AnswerType> {
  source: Application | ApplicantProfile;
  field: Field;
  answer?: AnswerType;
  previousAnswer?: AnswerType;
  showDiff?: boolean;
  defaultValue?: string;
}

export interface RadioGroupAnswer {
  [key: string]: boolean;
}
export interface ComplexFieldAnswer {
  [key: string]: FieldAnswer;
}
[];

export type FieldAnswer =
  | boolean
  | number
  | number
  | string
  | string[]
  | RadioGroupAnswer
  | ComplexFieldAnswer;

export function isString(answer: FieldAnswer): answer is string {
  return typeof answer === 'string';
}

export function isArray(answer: FieldAnswer): answer is string[] {
  return Array.isArray(answer);
}

// biome-ignore lint/suspicious/noExplicitAny: could contain any value, just type checking
export function isObject(answer: FieldAnswer): answer is Record<string, any> {
  return typeof answer === 'object';
}

export function isRadioGroupAnswer(answer: FieldAnswer): answer is RadioGroupAnswer {
  return (
    typeof answer === 'object' &&
    !isArray(answer) &&
    answer !== null &&
    Object.values(answer).every((value) => typeof value === 'boolean')
  );
}
